  <template>
  <div class="custom-actions">
    <button
      class="button is-success"
      v-bind:class="{ 'is-loading': isLoading }"
      @click="viewBatch(rowData, rowIndex)"
    >
      View
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      isLoading2: false,
      isLoading3: false,
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    viewBatch: (rowData) => {
      window.location = `/d/batches/${rowData._id}?type=${rowData.transactionType}`;
    },
  },
};
</script>

<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}

.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
</style>



// WEBPACK FOOTER //
// BatchActions.vue?0e248770